import { Box, Drawer } from "@mui/material"
import { EntityMetaDataComponent } from "./EntityMetaDataComponent"


interface InfoDrawerProps {
    open: boolean
    onClose?: () => void
    children?: JSX.Element
    entityUuid?: string
}

export default function InfoDrawer(props: InfoDrawerProps) {

    return (
        <Drawer
            open={props.open}
            onClose={props.onClose}
            PaperProps={{ style: { height: "77%" } }}
            anchor="bottom"
            >
            <Box style={{ position: 'relative' }}>
                <Box marginTop={2} marginRight={2} marginLeft={2} style={{ minHeight: '63vh' }} >
                    {props.children}
                </Box>

                {props.entityUuid &&
                    <Box style={{
                        maxHeight: '5vh',
                        position: 'absolute',
                        width: '100%'
                    }}>
                        {<EntityMetaDataComponent entity_uuid={props.entityUuid} />}
                    </Box>
                }
            </Box>
        </Drawer>
    )
}